Array.prototype.cast = function() {
  return this;
}

if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = () => {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return {promise, resolve: resolve, reject: reject};
  };
}
if (!globalThis.crypto || !globalThis.crypto.randomUUID) {
  if (!globalThis.crypto) {
    // @ts-expect-error:polyfill
    globalThis.crypto = {};
  }

  // @ts-expect-error:polyfill
  globalThis.crypto.randomUUID = () => {
    let
      d = new Date().getTime(),
      d2 = (performance && performance.now && (performance.now() * 1000)) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      let r = Math.random() * 16;
      if (d > 0) {
        r = (d + r) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        r = (d2 + r) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  };
}

// Extracts & strips the source query parameter (pk_source, else pks) from the URL and stores it in a cookie.
(() => {

  const sourceCookieName = 'referring_source';
  const entryUrlCookieName = 'referring_entry';
  const domains = ['.localhost', '.mindpath.com'];
  const paramStripDelay = 8_000;
  // In priority order. Ad blockers strip `pk_source` (a Piwik campaign param) before the page loads; `pks` survives them.
  const paramNames = ['pk_source', 'pks'];

  globalThis._MindPath = globalThis._MindPath || {};

  let {source, entryUrl, error} = loadFromCookies();

  try {

    const queryParams = new URLSearchParams(window.location.search);
    const keys = getCaseInsensitiveSearchParamsMapping(queryParams);

    const queryParamName = paramNames
      .map(name => keys[name])
      .find(key => key !== undefined && queryParams.get(key)?.trim()?.length);

    if (queryParamName === undefined) {
      return;
    }

    source = queryParams.get(queryParamName);

    // remove the source parameters from the URL
    const url = new URL(window.location.href);
    deleteSourceParams(url);
    entryUrl = url.toString();

    setCookies({
      source,
      entryUrl,
    });

    // By the time this fires the app has usually routed away from the entry URL, so strip the params
    // from wherever the page is now. Replacing with `entryUrl` would undo that navigation.
    setTimeout(stripParamsFromCurrentUrl, paramStripDelay);

  } catch (e) {
    error = e;
  } finally {
    globalThis._MindPath.referring = {
      source,
      entryUrl,
      error,
    };
  }

  function stripParamsFromCurrentUrl() {
    try {
      const url = new URL(window.location.href);
      if (!deleteSourceParams(url)) {
        return;
      }
      // keep the router's history state (navigation id, depth); replacing it with null breaks back/forward
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {
      globalThis._MindPath.referring.error = e;
    }
  }

  /**
   * Deletes every source parameter from the URL, matching names case-insensitively.
   * @param url {URL}
   * @returns {boolean} whether any were deleted
   */
  function deleteSourceParams(url) {
    const matching = Array.from(url.searchParams.keys()).filter(key => paramNames.includes(key.toLowerCase()));
    matching.forEach(key => url.searchParams.delete(key));
    return matching.length > 0;
  }

  function setCookies({source, entryUrl}) {

    // set the cookie to last for 24 hours
    const expirationDate = new Date();
    expirationDate.setHours(expirationDate.getHours() + 24);

    // try to set the cookie for all the domains provided
    // encoded: the entry URL carries `=`, `&` and possibly `;`, which would otherwise end the value early
    domains.forEach(domain => {
      document.cookie = `${sourceCookieName}=${encodeURIComponent(source)}; expires=${expirationDate.toUTCString()}; domain=${domain}; path=/`;
      document.cookie = `${entryUrlCookieName}=${encodeURIComponent(entryUrl)}; expires=${expirationDate.toUTCString()}; domain=${domain}; path=/`;
    });
  }

  /**
   * Loads the cookies from the document.
   * @returns {{error}|{source: string|undefined, entryUrl: string|undefined, error: undefined}}
   */
  function loadFromCookies() {
    try {

      const cookies = readCookies([sourceCookieName, entryUrlCookieName]);

      return {
        source: cookies[sourceCookieName],
        entryUrl: cookies[entryUrlCookieName],
        error: undefined,
      }

      function readCookies(names) {
        return names.reduce((acc, name) => {
          const cookie = document.cookie
            .split('; ')
            .find(row => row.startsWith(`${name}=`));

          if (cookie) {
            const value = cookie.slice(name.length + 1);
            try {
              acc[name] = decodeURIComponent(value);
            } catch {
              // written before values were encoded, and not valid percent-encoding: use it as-is
              acc[name] = value;
            }
          }
          return acc;
        }, {});

      }
    } catch (error) {
      return {
        error
      };
    }

  }

  /**
   * Returns a mapping of the search params to their lowercase keys.
   * @param params {URLSearchParams}
   * @returns {{[p: string]: string}}
   */
  function getCaseInsensitiveSearchParamsMapping(params) {
    return Object.fromEntries(Array.from(params.keys()).map(key => [key.toLowerCase(), key]));
  }

})();
